var _excluded = ["value", "placeholder", "name", "prefix", "suffix", "icon", "errorMessage", "hasError", "hasSuccess", "isPlaceholderVisibleWhenHasValue", "hasAutofocus", "onChange", "onKeyPress", "buttonText", "buttonTitle", "buttonColor", "buttonMobileIcon", "size", "list", "onSubmit", "hasWiderButton", "hasDisabledButton", "hasHiddenBorder", "shadow", "isFancy", "isLoading", "isIconVisibleWhenHasValue", "className", "onClick", "buttonDataTName", "buttonClassName", "backgroundColor", "readOnly", "role", "onKeyDown"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { shade } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space, { spaceFactor } from "../../../utils/space";
import unit from "../../../utils/unit";
import ButtonAtm from "../../atoms/ButtonAtm";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import InputMol from "../InputMol";
import { inputHeightSpace, inputSmallHeightSpace } from "../InputMol/InputMol.styled";
import { defaultProps } from "./SubmitInputMol.props";
var buttonMarginUnit = 10;
var Container = styled.div.withConfig({
  componentId: "sc-gnpoia-0"
})(["position:relative;"]);
var StyledInput = styled(InputMol).withConfig({
  componentId: "sc-gnpoia-1"
})(function (_ref) {
  var $buttonWidth = _ref.$buttonWidth,
    $isFancy = _ref.$isFancy,
    $hasHiddenBorder = _ref.$hasHiddenBorder,
    $hasError = _ref.$hasError,
    $hasSuccess = _ref.$hasSuccess,
    $isLoading = _ref.$isLoading,
    $onColor = _ref.$onColor,
    $buttonColor = _ref.$buttonColor,
    shadow = _ref.shadow,
    theme = _ref.theme;
  return css(["input{", " ", " ", " ", "}"], !!$buttonWidth && css(["padding-right:", ";"], unit($buttonWidth + 2 * buttonMarginUnit)), !!$isFancy && css(["", ""], $hasError || $hasSuccess || $isLoading ? css(["border-color:", ";"], getBorderColor(theme, $onColor, "medium")) : css(["border-color:", ";"], getColor(theme, $buttonColor))), $hasHiddenBorder && css(["border:none;"]), shadow && css(["box-shadow:", ";"], getBoxShadow(theme, shadow)));
});
var StyledButton = styled(ButtonAtm).withConfig({
  componentId: "sc-gnpoia-2"
})(function (_ref2) {
  var _ref2$$buttonColor = _ref2.$buttonColor,
    $buttonColor = _ref2$$buttonColor === void 0 ? defaultProps.buttonColor : _ref2$$buttonColor,
    $isFancy = _ref2.$isFancy,
    $hasIcon = _ref2.$hasIcon,
    $inputSize = _ref2.$inputSize,
    theme = _ref2.theme;
  var colorValue = getColor(theme, $buttonColor);
  var backgroundHover = shade(0.15, colorValue);
  var inputSizeHeightSpace = $inputSize === "small" ? inputSmallHeightSpace : inputHeightSpace;
  return css(["position:absolute;top:", ";right:", ";height:", ";background-color:", ";&:hover{background-color:", ";}", " ", ""], unit(buttonMarginUnit), unit(buttonMarginUnit), space(inputSizeHeightSpace - 2 * buttonMarginUnit * spaceFactor), colorValue, backgroundHover, !!$isFancy && css(["top:0;right:0;height:", ";border-top-left-radius:0;border-bottom-left-radius:0;"], space(inputSizeHeightSpace)), !!$hasIcon && css(["> svg{margin-right:0;}"]));
});
function SubmitInputMol(_ref3) {
  var value = _ref3.value,
    placeholder = _ref3.placeholder,
    name = _ref3.name,
    prefix = _ref3.prefix,
    suffix = _ref3.suffix,
    icon = _ref3.icon,
    errorMessage = _ref3.errorMessage,
    hasError = _ref3.hasError,
    hasSuccess = _ref3.hasSuccess,
    isPlaceholderVisibleWhenHasValue = _ref3.isPlaceholderVisibleWhenHasValue,
    hasAutofocus = _ref3.hasAutofocus,
    onChange = _ref3.onChange,
    onKeyPress = _ref3.onKeyPress,
    buttonText = _ref3.buttonText,
    buttonTitle = _ref3.buttonTitle,
    _ref3$buttonColor = _ref3.buttonColor,
    buttonColor = _ref3$buttonColor === void 0 ? defaultProps.buttonColor : _ref3$buttonColor,
    buttonMobileIcon = _ref3.buttonMobileIcon,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? defaultProps.size : _ref3$size,
    list = _ref3.list,
    onSubmit = _ref3.onSubmit,
    hasWiderButton = _ref3.hasWiderButton,
    hasDisabledButton = _ref3.hasDisabledButton,
    hasHiddenBorder = _ref3.hasHiddenBorder,
    shadow = _ref3.shadow,
    isFancy = _ref3.isFancy,
    isLoading = _ref3.isLoading,
    isIconVisibleWhenHasValue = _ref3.isIconVisibleWhenHasValue,
    className = _ref3.className,
    onClick = _ref3.onClick,
    buttonDataTName = _ref3.buttonDataTName,
    buttonClassName = _ref3.buttonClassName,
    backgroundColor = _ref3.backgroundColor,
    readOnly = _ref3.readOnly,
    role = _ref3.role,
    onKeyDown = _ref3.onKeyDown,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var onColor = useContext(OnColorContext);
  var isSmallOnly = useBreakpoint("small", "medium");
  var buttonRef = useRef(null);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    buttonWidth = _useState2[0],
    setButtonWidth = _useState2[1];
  var setButtonWidthValue = function setButtonWidthValue() {
    var _buttonRef$current;
    return setButtonWidth((_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.offsetWidth);
  };
  var handleWindowResize = useCallback(function () {
    setButtonWidthValue();
  }, []);
  useEffect(function () {
    setButtonWidthValue();
  }, [buttonText, hasWiderButton, isSmallOnly]);
  useEffect(function () {
    window.addEventListener("resize", handleWindowResize);
    return function () {
      return window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);
  var buttonSize;
  if (size === "small") {
    buttonSize = isFancy ? "default" : "small";
  } else {
    buttonSize = isFancy ? "big" : undefined;
  }
  var buttonCommon = {
    title: buttonTitle,
    onClick: onSubmit,
    isDisabled: hasDisabledButton,
    isLoading: isLoading,
    size: buttonSize,
    $buttonColor: buttonColor,
    $isFancy: isFancy,
    ref: buttonRef,
    $inputSize: size,
    dataTName: buttonDataTName,
    className: buttonClassName,
    onKeyDown: onKeyDown
  };
  return /*#__PURE__*/React.createElement(Container, _extends({
    role: role
  }, restProps), /*#__PURE__*/React.createElement(StyledInput, {
    value: value,
    placeholder: placeholder,
    prefix: prefix,
    suffix: suffix,
    icon: icon,
    errorMessage: errorMessage,
    $hasHiddenBorder: hasHiddenBorder,
    hasError: hasError,
    hasSuccess: hasSuccess,
    isPlaceholderVisibleWhenHasValue: isPlaceholderVisibleWhenHasValue,
    hasAutofocus: hasAutofocus,
    onChange: onChange,
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown,
    $buttonWidth: buttonWidth,
    $isFancy: isFancy,
    $hasError: hasError,
    $hasSuccess: hasSuccess,
    $isLoading: isLoading,
    isIconVisibleWhenHasValue: isIconVisibleWhenHasValue,
    $onColor: onColor,
    shadow: shadow,
    size: size,
    name: name,
    className: className,
    list: list,
    $buttonColor: buttonColor,
    backgroundColor: backgroundColor,
    onClick: onClick,
    readOnly: readOnly
  }), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, /*#__PURE__*/React.createElement(StyledButton, _extends({}, buttonCommon, {
    icon: buttonMobileIcon !== null && buttonMobileIcon !== void 0 ? buttonMobileIcon : undefined,
    $hasIcon: !!buttonMobileIcon
  }))), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(StyledButton, _extends({}, buttonCommon, {
    isWider: size !== "small" && (hasWiderButton || isFancy)
  }), buttonText)));
}
export default SubmitInputMol;